import React, { useState, useEffect } from 'react';
import api from '../api';

const Brands = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [busyId, setBusyId] = useState(null);

  const load = () => {
    setLoading(true);
    api.get('/brands/')
      .then(res => setRows(Array.isArray(res.data) ? res.data : res.data.results || []))
      .catch(() => setError('Failed to load brands'))
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  const sync = async (id) => {
    setBusyId(id);
    setError('');
    try {
      await api.post(`/brands/${id}/sync/`);
      load();
    } catch {
      setError('Sync failed');
    } finally {
      setBusyId(null);
    }
  };

  if (loading) return <div>Loading...</div>;

  return (
    <div>
      <div className="flex-between">
        <h2>Brands</h2>
      </div>
      {error && <div className="error">{error}</div>}
      <table className="table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Status</th>
            <th>Last Sync</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {rows.map(r => (
            <tr key={r.id}>
              <td>{r.name}</td>
              <td><span className={`badge ${r.status}`}>{r.status}</span></td>
              <td>{r.last_sync ? new Date(r.last_sync).toLocaleString() : '—'}</td>
              <td>
                <button className="btn btn-primary" onClick={() => sync(r.id)} disabled={busyId === r.id}>
                  {busyId === r.id ? 'Syncing...' : 'Sync'}
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Brands;
